import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MenuService } from '@core/menu/menu.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'fc-sidebar-item',
  templateUrl: './sidebar-item.component.html',
  styleUrl: './sidebar.component.scss',
  standalone: true,
  providers: [MenuService],
  imports: [RouterModule, MatIconModule],
})
export class SidebarItemComponent {
  private readonly menuService = inject(MenuService);

  readonly menuIcon = input<string>();
  readonly menuTitle = input.required<string>();
  readonly path = input<string>();

  closeMenu(): void {
    this.menuService.closeMenu();
  }
}
